import type { BodyUpdateTemplate } from "@/common/types/notesTemplates";
import { useVisitWrites } from "@/hooks/visits/useVisitWrites";

export const useUpdateNoteTemplate = (visitPublicId: string) => {
  const { updateVisitNote, result, loading, error } = useVisitWrites();
  return {
    updateTemplate: (body: BodyUpdateTemplate): Promise<boolean> =>
      updateVisitNote({
        params: {
          public_id: String(visitPublicId),
          notePublicId: body.public_id,
        },
        query: {},
        body: { result: body.result },
      }),
    result,
    loading,
    error,
  };
};
